module.exports = __webpack_public_path__ + "img/1.34f4d4e5.png";